import React, { useEffect, useState } from "react";
import "./Select_Product_By_Weight_Modal.css";
import { Form, Modal } from "react-bootstrap";
import { faBasketShopping, faX } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import IncrementDecrementBtn from "../../Increment_Decrement_Btn/Increment_Decrement_Btn";
import Green_Btn from "../../common_btn/green_btn/Green_Btn";
import Common_Goto_Cart_Card from "../../common_goto_cart_card/Common_Goto_Cart_Card";
import { getAllCart, postCart } from "../../../../features/cart/cartSlice";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import Increment_Decrement_Btn_Simple from "../../Increment_Decrement_Btn/Increment_Decrement_Btn_Simple";
import { useNavigate } from "react-router-dom";
function Select_Product_Cart_Modal(props) {
  const dispatch = useDispatch();
  const isSignIn = useSelector((state) => state.auth.is_signin);
  const allCart = useSelector((state) => state.cart.allCarts);

  const [Errors, setErrors] = useState("");
  const [selectedVariant, setSelectedVariant] = useState(
    props.product?.Product_Variants?.[0] || null
  );

  useEffect(() => {
    if (props.product?.Product_Variants?.length) {
      setSelectedVariant(props.product.Product_Variants[0]);
      setSelectedAddOns({});
      setQuantity(1);
    }
  }, [props.product]);

  const [selectedAddOns, setSelectedAddOns] = useState({});
  const [showFooter, setShowFooter] = useState(false);
  const [footerClosing, setFooterClosing] = useState(false);
  const [cartChanged, setCartChanged] = useState(false);

  const closeFooter = () => {
    setFooterClosing(true);
    setTimeout(() => {
      setShowFooter(false);
      setFooterClosing(false);
    }, 300);
  };

  const [quantity, setQuantity] = useState(1);

  useEffect(() => {
    if (!selectedVariant) return;

    if (isSignIn) {
      // Logged-in user logic
      if (!allCart?.data?.data?.length) return;

      const cartItem = allCart.data.data.find(
        (item) => item.variant_id === selectedVariant.id
      );
      if (!cartItem) return;

      const preSelected = {};

      // Multiple addons (Checkbox)
      cartItem.Cart_Addon_Multiples?.forEach((addon) => {
        if (!preSelected[addon.addon_category_id])
          preSelected[addon.addon_category_id] = [];
        preSelected[addon.addon_category_id].push({
          addon_category_id: addon.addon_category_id,
          product_addon_id: addon.product_addon_id,
          addon_id: addon.addon_id,
          type: addon.Addon_Category.type,
          price: Number(addon.price),
        });
      });

      // Single addon (Radio)
      cartItem.Cart_Addon_Singles?.forEach((addon) => {
        preSelected[addon.addon_category_id] = [
          {
            addon_category_id: addon.addon_category_id,
            product_addon_id: addon.product_addon_id,
            addon_id: addon.addon_id,
            type: addon.Addon_Category.type,
            price: Number(addon.price),
          },
        ];
      });

      setSelectedAddOns(preSelected);
    } else {
      // Guest user logic
      const guestCart = Cookies.get("Chefcut_Cart");
      const cartItems = guestCart ? JSON.parse(guestCart) : [];

      const cartItem = cartItems.find(
        (item) => item.variant_id === selectedVariant.id
      );

      if (!cartItem) {
        setSelectedAddOns({});
        return;
      }

      // cartItem.selectedAddOns is already in the correct format
      setSelectedAddOns(cartItem.selectedAddOns || {});
    }
  }, [allCart, selectedVariant, isSignIn]);

  // ----- Handle Addon Selection -----
  const handleAddonChange = (
    categoryId,
    productAddonId,
    addonId,
    type,
    checked,
    price,
    addon_category_name,
    addon_name
  ) => {
    setCartChanged(true);
    setSelectedAddOns((prev) => {
      const prevSelected = prev[categoryId] || [];

      if (type === "Checkbox") {
        if (checked) {
          return {
            ...prev,
            [categoryId]: [
              ...prevSelected,
              {
                addon_category_id: categoryId,
                product_addon_id: productAddonId,
                addon_id: addonId,
                type,
                price,
                addon_category_name: addon_category_name,
                addon_name: addon_name,
              },
            ],
          };
        } else {
          return {
            ...prev,
            [categoryId]: prevSelected.filter(
              (item) => item.product_addon_id !== productAddonId
            ),
          };
        }
      } else {
        return {
          ...prev,
          [categoryId]: [
            {
              addon_category_id: categoryId,
              product_addon_id: productAddonId,
              addon_id: addonId,
              type,
              price,
              addon_category_name: addon_category_name,
              addon_name: addon_name,
            },
          ],
        };
      }
    });
  };

  const nevigate = useNavigate();
  const addToCart = async (product_id, variant_id, quantity) => {
    if (Number(selectedVariant?.general_stock) <= 0) {
      setErrors("Out of Stock");
      return;
    }

    const requiredCategories =
      props.product?.Product_Addon_Categories?.filter(
        (cat) => cat?.Addon_Category?.required_status
      ) || [];

    for (const category of requiredCategories) {
      const categoryId = category?.Addon_Category?.id;
      const selected = selectedAddOns[categoryId];

      if (!selected || selected.length === 0) {
        setErrors(
          `Please select at least one option for "${category?.Addon_Category?.name}".`
        );
        return; // stop execution
      }
    }

    setErrors("");
    setShowFooter(true);

    try {
      const data = { quantity, product_id, variant_id, selectedAddOns };
      const res = await dispatch(postCart({ data, isSignIn }));
      if (res.meta?.requestStatus === "fulfilled") {
        await dispatch(getAllCart(isSignIn));
        setCartChanged(false);
        nevigate("/cart");
      } else {
        console.log("Error:", res.payload || "Not In Cart");
      }
    } catch (error) {
      console.log("Error:", error);
    }
  };

  // ----- Update Cart -----
  const updateCart = async () => {
    const cartItem = allCart.data.data.find(
      (item) => item.variant_id === selectedVariant.id
    );
    if (!cartItem) return;

    const data = {
      cart_id: cartItem.id,
      product_id: selectedVariant.product_id,
      variant_id: selectedVariant.id,
      selectedAddOns,
    };

    try {
      const res = await dispatch(postCart({ data, isSignIn }));
      if (res.meta?.requestStatus === "fulfilled") {
        await dispatch(getAllCart(isSignIn));
        setCartChanged(false);
      } else {
        console.log("Error updating cart:", res.payload);
      }
    } catch (error) {
      console.log("Error:", error);
    }
  };

  // ----- Check if variant is in cart -----
  const inCart = (variantId) =>
    allCart?.data?.data?.some((item) => item?.variant_id === variantId);

  const getTotalPrice = () => {
    let total = 0;

    if (!selectedVariant) return total;

    // Base price of selected variant
    const variantPrice = Number(selectedVariant?.price) || 0;

    // Quantity if variant exists in cart, else 1
    const cartItem = allCart?.data?.data?.find(
      (item) => item.variant_id === selectedVariant?.id
    );
    const qty = cartItem ? Number(cartItem.quantity) : 1;

    total += variantPrice * qty;

    // Add selected add-ons
    Object.entries(selectedAddOns).forEach(([categoryId, selectedItems]) => {
      selectedItems.forEach((item) => {
        const addonPrice = Number(item.price) || 0;
        total += addonPrice * qty;
      });
    });

    return total;
  };

  // ----- Footer totals -----
  const saveTotal = () => {
    let total = 0;
    let savings = 0;
    let count = 0;

    if (allCart?.data?.data?.length > 0) {
      for (const element of allCart?.data?.data) {
        const price = Number(element?.Product_Variant?.price);
        const mrp = Number(element?.Product_Variant?.mrp);
        const qty = Number(element.quantity);
        total += price * qty;
        savings += (mrp - price) * qty;
        count += 1;
      }
    }

    return { total, savings, count };
  };

  

  return (
    <section className="Select_Product_By_Weight_Modal modal-holder">
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="Select_Product_By_Weight_Modal modal-holder"
      >
        <Modal.Body>
          {/* Header */}
          <div className="header_part">
            <div className="left_side">
              <div className="img_holder">
                <img
                  src={process.env.REACT_APP_IMG_URL + props?.product?.image}
                />
              </div>
              <div className="product_name">
                <p>{props?.product?.name}</p>
              </div>
            </div>
            <div className="right_side">
              <FontAwesomeIcon
                icon={faX}
                className="close_icon"
                onClick={props?.onHide}
              />
            </div>
          </div>

          {/* Body */}
          <div className="body_part">
            {/* Variant Info */}
            {props?.product?.Product_Variants?.map((variant) => (
              <div className="row_holder" key={variant.id}>
                <div className="left_side Product_Description">
                  <div className="product_price_info">
                    <div className="price_section">
                      <div className="kilo_div_text_holder">
                        <div>
                          <div className="kilo_div">
                            <p className="kilo_text">
                              {variant.name} {props?.product?.Unit?.name}
                            </p>
                          </div>
                          <div className="main_price_holder">
                            <div className="selling_price">
                              <p> ₹{variant.price}</p>
                            </div>
                            <div className="mrp">
                              <p>₹{variant.mrp}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
            {/* Addon Selection */}
            <div className="option_list_holder">
              {props.product?.Product_Addon_Categories?.map((val) => (
                <div className="option_group" key={val?.Addon_Category?.id}>
                  <div className="option_title">
                    <p>
                      {val?.Addon_Category?.name}{" "}
                      <span className="optional">
                        {val?.Addon_Category?.required_status
                          ? "Required"
                          : "Optional"}
                      </span>
                    </p>
                  </div>
                  <Form>
                    {val?.Product_AddOns?.map((portion, idx) => (
                      <div className="option_list" key={idx}>
                        <Form.Check
                          type={
                            val?.Addon_Category?.type === "Checkbox"
                              ? "checkbox"
                              : "radio"
                          }
                          id={`addon-${val?.Addon_Category?.id}-${idx}`}
                          name={`addon-${val?.Addon_Category?.id}`}
                          label={portion?.Addon?.name}
                          checked={
                            selectedAddOns[val?.Addon_Category?.id]?.some(
                              (item) => item.product_addon_id === portion?.id
                            ) || false
                          }
                          onChange={(e) =>
                            handleAddonChange(
                              val?.Addon_Category?.id,
                              portion.id,
                              portion?.Addon?.id,
                              val?.Addon_Category?.type,
                              e.target.checked,
                              portion?.price,
                              val?.Addon_Category?.name,
                              portion?.Addon?.name
                            )
                          }
                        />
                        <p className="option_price_text">
                          {Number(portion?.price) > 0 ? portion?.price : "Free"}
                        </p>
                      </div>
                    ))}
                  </Form>
                </div>
              ))}
            </div>
            {/* Cart Actions */}
            <div className="right_side">
              <div>Total: ₹{getTotalPrice()}</div>
              <div className="btn_holder">
                {Number(selectedVariant?.general_stock) <= 0 ? (
                  <button className="btn btn-danger" disabled>
                    Out of Stock
                  </button>
                ) : (
                  <>
                    {" "}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "start",
                        gap: "10px",
                      }}
                    >
                      <Increment_Decrement_Btn_Simple
                        varient={selectedVariant}
                        product={props?.product}
                        varientId={selectedVariant?.id}
                        cart={allCart?.data?.data}
                        productId={props?.product?.id}
                        isSignIn={isSignIn}
                        setQuantity={setQuantity}
                        quantity={quantity}
                      />
                      <Green_Btn
                        varient={selectedVariant}
                        btn_name="Add to Cart"
                        leftIcon={faBasketShopping}
                        onClick={() =>
                          addToCart(
                            selectedVariant?.product_id,
                            selectedVariant?.id,
                            quantity
                          )
                        }
                      />
                    </div>
                  </>
                )}
              </div>
              {Errors && <p style={{ color: "red" }}>{Errors}</p>}
            </div>

            {/* <div className="right_side">
              <div>Total: ₹{getTotalPrice()}</div>
              <div className="btn_holder">
                {Number(selectedVariant?.general_stock) <= 0 ? (
                  <button className="btn btn-danger" disabled>
                    Out of Stock
                  </button>
                ) : inCart(selectedVariant.id) ? (
                  cartChanged ? (
                    <Green_Btn
                      // btn_name="Update Cart"
                      btn_name="Add to Cart"
                      leftIcon={faBasketShopping}
                      onClick={updateCart}
                    />
                  ) : (
                    <IncrementDecrementBtn
                      varient={selectedVariant}
                      product={props?.product}
                      varientId={selectedVariant?.id}
                      cart={allCart?.data?.data}
                      productId={props?.product?.id}
                      isSignIn={isSignIn}
                    />
                  )
                ) : (
                  <Green_Btn
                    varient={selectedVariant}
                    btn_name="Add to Cart"
                    leftIcon={faBasketShopping}
                    onClick={() =>
                      addToCart(
                        selectedVariant?.product_id,
                        selectedVariant?.id
                      )
                    }
                  />
                )}
                {Errors && <p style={{ color: "red" }}>{Errors}</p>}
              </div>
            </div> */}
          </div>
        </Modal.Body>

        {/* Footer */}
        {showFooter && (
          <Modal.Footer
            className={`GotoCartModal ${footerClosing ? "slide-out-left" : ""}`}
          >
            <div className="modal-content">
              <div className="modal-body">
                <Common_Goto_Cart_Card
                  inCart={props?.product}
                  saveTotal={saveTotal}
                  onClose={closeFooter}
                />
              </div>
            </div>
          </Modal.Footer>
        )}
      </Modal>
    </section>
  );
}

export default Select_Product_Cart_Modal;
